import { c as _c } from "react/compiler-runtime";
export const VaultDistributionPageErrorNotice = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p data-testid="vault-distribution-page-error-notice" className="text-secondary-foreground text-sm">The next page could not be loaded. Try again.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};